/* eslint-disable */
import { DefaultRoute } from "../router/routes";

// ** Checks if an object is empty (returns boolean)
export const isObjEmpty = (obj) => Object.keys(obj).length === 0;

// ** Returns K format from a number
export const kFormatter = (num) =>
  num > 999 ? `${(num / 1000).toFixed(1)}k` : num;

// ** Converts HTML to string
export const htmlToString = (html) => html.replace(/<\/?[^>]+(>|$)/g, "");

/* eslint-disable */
// ** Checks if the passed date is today
const isToday = (date) => {
  const today = new Date();
  return (
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
  );
};

/**
 ** Format and return date in Humanize format
 ** Intl docs: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/format
 ** Intl Constructor: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat
 * @param {String} value date to format
 * @param {Object} formatting Intl object to format with
 */
export const formatDate = (
  value,
  formatting = { month: "short", day: "numeric", year: "numeric" }
) => {
  if (!value) return value;
  return new Intl.DateTimeFormat("en-US", formatting).format(new Date(value));
};

// ** Returns short month of passed date
export const formatDateToMonthShort = (value, toTimeForCurrentDay = true) => {
  const date = new Date(value);
  let formatting = { month: "short", day: "numeric" };

  if (toTimeForCurrentDay && isToday(date)) {
    formatting = { hour: "numeric", minute: "numeric" };
  }

  return new Intl.DateTimeFormat("en-US", formatting).format(new Date(value));
};

/**
 ** Return if user is logged in
 ** This is completely up to you and how you want to store the token in your frontend application
 *  ? e.g. If you are using cookies to store the application please update this function
 */
export const isUserLoggedIn = () => localStorage.getItem("userData");
export const getUserData = () => JSON.parse(localStorage.getItem("userData"));

/**
 ** This function is used for demo purpose route navigation
 ** In real app you won't need this function because your app will navigate to same route for each users regardless of ability
 ** Please note role field is just for showing purpose it's not used by anything in frontend
 ** We are checking role just for ease
 * ? NOTE: If you have different pages to navigate based on user ability then this function can be useful. However, you need to update it.
 * @param {String} userRole Role of user
 */
export const getHomeRouteForLoggedInUser = (userRole) => {
  if (userRole === "admin") return DefaultRoute;
  // if (userRole === "client") return "/access-control";
  // return "/login";
};

// ** React Select Theme Colors
export const selectThemeColors = (theme) => ({
  ...theme,
  colors: {
    ...theme.colors,
    primary25: "#7367f01a", // for option hover bg-color
    primary: "#7367f0", // for selected option bg-color
    neutral10: "#7367f0", // for tags bg-color
    neutral20: "#ededed", // for input border-color
    neutral30: "#ededed", // for input hover border-color
  },
});

/* eslint-disable */
export function downloadCSV(array, name, fromDate, toDate) {
  const table = document.createElement("table");
  table.style.borderCollapse = "collapse"; // Add border-collapse CSS property

  const getUserData = JSON.parse(localStorage.getItem("userData"));
  const companyName = getUserData.cName || "";
  const companyAddress = getUserData.Usr_Address || "";
  const companyphone = getUserData.Usr_Phone || "";
  const companyEmail = getUserData.Usr_email || "";
  const companyGst = getUserData.Usr_Gst || "";
  const companyVat = getUserData.Usr_Vat || "";

  // Format the toDate to yy/mm/dd
  const toDateObj = new Date(toDate);
  const yy = toDateObj.getFullYear().toString(); // Get the last two digits of the year
  const mm = String(toDateObj.getMonth() + 1).padStart(2, "0"); // Month is 0-based, so add 1
  const dd = String(toDateObj.getDate()).padStart(2, "0");

  // Format the toDate to yy/mm/dd
  const toDateObj1 = new Date(fromDate);
  const y = toDateObj1.getFullYear().toString(); // Get the last two digits of the year
  const m = String(toDateObj1.getMonth() + 1).padStart(2, "0"); // Month is 0-based, so add 1
  const d = String(toDateObj1.getDate()).padStart(2, "0");

  // Add a row for company name
  const infoRow = table.insertRow(0);
  const infoCell = infoRow.insertCell();
  infoCell.colSpan = Object.keys(array[0]).length;
  infoCell.innerHTML = ` <strong>${companyName}</strong>`;
  infoCell.style.border = "1px solid #000"; // Add border to info cell
  infoCell.style.padding = "8px"; // Add padding to info cell
  infoCell.style.textAlign = "center"; // Add taxt align to info cell
  infoCell.style.backgroundColor = "#DEF7DF"; // Add background color to info cell
  infoCell.style.fontSize = "30px"; // Add background color to info cell

  // Add a row for file name
  const infoRow1 = table.insertRow(1);
  const infoCell1 = infoRow1.insertCell();
  infoCell1.colSpan = Object.keys(array[0]).length;
  infoCell1.innerHTML = ` ${companyAddress} `;
  infoCell1.style.border = "1px solid #000"; // Add border to info cell
  infoCell1.style.padding = "8px"; // Add padding to info cell
  infoCell1.style.textAlign = "center"; // Add taxt align to info cell
  infoCell1.style.backgroundColor = "#DEF7DF"; // Add background color to info cell

  // Add a row for from date, and to date
  const infoRow2 = table.insertRow(2);
  const infoCell2 = infoRow2.insertCell();
  infoCell2.colSpan = Object.keys(array[0]).length;
  infoCell2.innerHTML = ` <strong>VAT TIN:</strong> ${companyVat}, /<strong>GST NO:</strong> ${companyGst}`;
  infoCell2.style.border = "1px solid #000"; // Add border to info cell
  infoCell2.style.padding = "8px"; // Add padding to info cell
  infoCell2.style.textAlign = "center"; // Add taxt align to info cell
  infoCell2.style.backgroundColor = "#DEF7DF"; // Add background color to info cell

  // Add a row for from date, and to date
  const infoRow3 = table.insertRow(3);
  const infoCell3 = infoRow3.insertCell();
  infoCell3.colSpan = Object.keys(array[0]).length;
  infoCell3.innerHTML = ` <strong>PHONE NO:</strong> ${companyphone}, <strong>EMAIL:</strong> ${companyEmail}`;
  infoCell3.style.border = "1px solid #000"; // Add border to info cell
  infoCell3.style.padding = "8px"; // Add padding to info cell
  infoCell3.style.textAlign = "center"; // Add taxt align to info cell
  infoCell3.style.backgroundColor = "#DEF7DF"; // Add background color to info cell

  // Add a row for file name
  // const infoRow4 = table.insertRow(4);
  // const infoCell4 = infoRow1.insertCell();
  // infoCell4.colSpan = Object.keys(array[0]).length;
  // infoCell4.innerHTML = ` <strong>Report Name:</strong> ${name}`;
  // infoCell4.style.border = "1px solid #000"; // Add border to info cell
  // infoCell1.style.padding = "8px"; // Add padding to info cell
  // infoCell4.style.textAlign = "center"; // Add taxt align to info cell
  // infoCell1.style.backgroundColor = "#DEF7DF"; // Add background color to info cell

  // // Add a row for from date, and to date
  // const infoRow3 = table.insertRow(2);
  // const infoCell3 = infoRow3.insertCell();
  // infoCell3.colSpan = Object.keys(array[0]).length;
  // infoCell3.innerHTML = ` <strong>From Date:</strong> ${y}-${m}-${d}, <strong>To Date:</strong> ${yy}-${mm}-${dd}`;
  // infoCell3.style.border = "1px solid #000"; // Add border to info cell
  // infoCell3.style.padding = "8px"; // Add padding to info cell
  // infoCell3.style.textAlign = "center"; // Add taxt align to info cell
  // infoCell3.style.backgroundColor = "#DEF7DF"; // Add background color to info cell

  // Create a spacer row
  const spacerRow = table.insertRow(7);
  const spacerCell = spacerRow.insertCell();
  spacerCell.colSpan = Object.keys(array[0]).length;
  spacerCell.style.border = "none"; // Remove border for spacer cell
  spacerCell.style.height = "10px"; // Add height for spacer cell

  // Create header cells
  const headerRow = table.insertRow(8);
  Object.keys(array[0]).forEach((key) => {
    const headerCell = headerRow.insertCell();
    headerCell.innerHTML = key;
    headerCell.style.border = "1px solid #000"; // Add border to header cell
    headerCell.style.padding = "8px"; // Add padding to header cell
    headerCell.style.fontWeight = "bold"; // Make header cell bold
  });

  // Add data rows
  array.forEach((item) => {
    const row = table.insertRow();
    Object.values(item).forEach((value) => {
      const cell = row.insertCell();
      cell.innerHTML = value;
      cell.style.border = "1px solid #000"; // Add border to data cell
      cell.style.padding = "8px"; // Add padding to data cell
    });
  });

  const html = table.outerHTML;

  const blob = new Blob(
    [
      '<html xmlns:x="urn:schemas-microsoft-com:office:excel">',
      "<head>",
      "<!--[if gte mso 9]>",
      "<xml>",
      "<x:ExcelWorkbook>",
      "<x:ExcelWorksheets>",
      "<x:ExcelWorksheet>",
      "<x:Name>Sheet1</x:Name>",
      "<x:WorksheetOptions>",
      "<x:DisplayGridlines/>",
      "</x:WorksheetOptions>",
      "</x:ExcelWorksheet>",
      "</x:ExcelWorksheets>",
      "</x:ExcelWorkbook>",
      "</xml>",
      "<![endif]-->",
      "</head>",
      "<body>",
      html,
      "</body>",
      "</html>",
    ],
    {
      type: "application/vnd.ms-excel;charset=utf-8",
    }
  );

  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);
  link.href = url;
  link.download = `${name}.xls`;
  link.click();
  URL.revokeObjectURL(url);
}

const removeFirstChar = (string) => {
  return string.length === 3 ? string.substring(1) : string;
};

export const createDate = (date) => {
  const oldDate = new Date(date);
  const getFullYear = oldDate.getFullYear();
  const getMonth = `0${oldDate.getMonth() + 1}`;
  const getDate = `0${oldDate.getDate()}`;

  const newDate = `${getFullYear}-${removeFirstChar(
    getMonth
  )}-${removeFirstChar(getDate)}`;
  return newDate;
};

// for one date
export function downloadExcelDate(array, name, date, companyName) {
  const table = document.createElement("table");
  table.style.borderCollapse = "collapse"; // Add border-collapse CSS property

  // Format the toDate to yy/mm/dd
  const toDateObj = new Date(date);
  const yy = toDateObj.getFullYear().toString(); // Get the last two digits of the year
  const mm = String(toDateObj.getMonth() + 1).padStart(2, "0"); // Month is 0-based, so add 1
  const dd = String(toDateObj.getDate()).padStart(2, "0");

  // Add a row for company name
  const infoRow = table.insertRow(0);
  const infoCell = infoRow.insertCell();
  infoCell.colSpan = Object.keys(array[0]).length;
  infoCell.innerHTML = ` <strong>Compnay Name: ${companyName}</strong>`;
  infoCell.style.border = "1px solid #000"; // Add border to info cell
  infoCell.style.padding = "8px"; // Add padding to info cell
  infoCell.style.textAlign = "center"; // Add taxt align to info cell
  infoCell.style.backgroundColor = "#DEF7DF"; // Add background color to info cell
  infoCell.style.fontSize = "30px"; // Add background color to info cell

  // Add a row for file name
  const infoRow1 = table.insertRow(1);
  const infoCell1 = infoRow1.insertCell();
  infoCell1.colSpan = Object.keys(array[0]).length;
  infoCell1.innerHTML = ` <strong>Report Name:</strong> ${name}`;
  infoCell1.style.border = "1px solid #000"; // Add border to info cell
  infoCell1.style.padding = "8px"; // Add padding to info cell
  infoCell1.style.textAlign = "center"; // Add taxt align to info cell
  infoCell1.style.backgroundColor = "#DEF7DF"; // Add background color to info cell

  // Add a row for from date, and to date
  const infoRow3 = table.insertRow(2);
  const infoCell3 = infoRow3.insertCell();
  infoCell3.colSpan = Object.keys(array[0]).length;
  infoCell3.innerHTML = ` <strong>Date:</strong> ${yy}-${mm}-${dd}`;
  infoCell3.style.border = "1px solid #000"; // Add border to info cell
  infoCell3.style.padding = "8px"; // Add padding to info cell
  infoCell3.style.textAlign = "center"; // Add taxt align to info cell
  infoCell3.style.backgroundColor = "#DEF7DF"; // Add background color to info cell

  // Create a spacer row
  const spacerRow = table.insertRow(3);
  const spacerCell = spacerRow.insertCell();
  spacerCell.colSpan = Object.keys(array[0]).length;
  spacerCell.style.border = "none"; // Remove border for spacer cell
  spacerCell.style.height = "10px"; // Add height for spacer cell

  // Create header cells
  const headerRow = table.insertRow(3);
  Object.keys(array[0]).forEach((key) => {
    const headerCell = headerRow.insertCell();
    headerCell.innerHTML = key;
    headerCell.style.border = "1px solid #000"; // Add border to header cell
    headerCell.style.padding = "8px"; // Add padding to header cell
    headerCell.style.fontWeight = "bold"; // Make header cell bold
  });

  // Add data rows
  array.forEach((item) => {
    const row = table.insertRow();
    Object.values(item).forEach((value) => {
      const cell = row.insertCell();
      cell.innerHTML = value;
      cell.style.border = "1px solid #000"; // Add border to data cell
      cell.style.padding = "8px"; // Add padding to data cell
    });
  });

  const html = table.outerHTML;

  const blob = new Blob(
    [
      '<html xmlns:x="urn:schemas-microsoft-com:office:excel">',
      "<head>",
      "<!--[if gte mso 9]>",
      "<xml>",
      "<x:ExcelWorkbook>",
      "<x:ExcelWorksheets>",
      "<x:ExcelWorksheet>",
      "<x:Name>Sheet1</x:Name>",
      "<x:WorksheetOptions>",
      "<x:DisplayGridlines/>",
      "</x:WorksheetOptions>",
      "</x:ExcelWorksheet>",
      "</x:ExcelWorksheets>",
      "</x:ExcelWorkbook>",
      "</xml>",
      "<![endif]-->",
      "</head>",
      "<body>",
      html,
      "</body>",
      "</html>",
    ],
    {
      type: "application/vnd.ms-excel;charset=utf-8",
    }
  );

  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);
  link.href = url;
  link.download = `${name}.xls`;
  link.click();
  URL.revokeObjectURL(url);
}

//for time slots of set target

export function downloadExcelDateT(array, name, date, companyName) {
  const table = document.createElement("table");
  table.style.borderCollapse = "collapse"; // Add border-collapse CSS property
  const response = date;
  const [startDateStr, endDateStr] = response.split("#");

  // Function to format date as "dd Month yyyy"
  const formatDate = (dateStr) => {
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const [year, month, day] = dateStr.split("-");
    const monthName = months[parseInt(month, 10) - 1];
    return `${day} ${monthName} ${year}`;
  };

  // Format start and end dates
  const formattedStartDate = formatDate(startDateStr);
  const formattedEndDate = formatDate(endDateStr);

  // Concatenate formatted dates
  const formattedDateRange = `${formattedStartDate} - ${formattedEndDate}`;

  // Add a row for company name
  const infoRow = table.insertRow(0);
  const infoCell = infoRow.insertCell();
  infoCell.colSpan = Object.keys(array[0]).length;
  infoCell.innerHTML = ` <strong>Compnay Name: ${companyName}</strong>`;
  infoCell.style.border = "1px solid #000"; // Add border to info cell
  infoCell.style.padding = "8px"; // Add padding to info cell
  infoCell.style.textAlign = "center"; // Add taxt align to info cell
  infoCell.style.backgroundColor = "#DEF7DF"; // Add background color to info cell
  infoCell.style.fontSize = "30px"; // Add background color to info cell

  // Add a row for file name
  const infoRow1 = table.insertRow(1);
  const infoCell1 = infoRow1.insertCell();
  infoCell1.colSpan = Object.keys(array[0]).length;
  infoCell1.innerHTML = ` <strong>Report Name:</strong> ${name}`;
  infoCell1.style.border = "1px solid #000"; // Add border to info cell
  infoCell1.style.padding = "8px"; // Add padding to info cell
  infoCell1.style.textAlign = "center"; // Add taxt align to info cell
  infoCell1.style.backgroundColor = "#DEF7DF"; // Add background color to info cell

  // Add a row for from date, and to date
  const infoRow3 = table.insertRow(2);
  const infoCell3 = infoRow3.insertCell();
  infoCell3.colSpan = Object.keys(array[0]).length;
  infoCell3.innerHTML = ` <strong>Date:</strong> ${formattedDateRange}`;
  infoCell3.style.border = "1px solid #000"; // Add border to info cell
  infoCell3.style.padding = "8px"; // Add padding to info cell
  infoCell3.style.textAlign = "center"; // Add taxt align to info cell
  infoCell3.style.backgroundColor = "#DEF7DF"; // Add background color to info cell

  // Create a spacer row
  const spacerRow = table.insertRow(3);
  const spacerCell = spacerRow.insertCell();
  spacerCell.colSpan = Object.keys(array[0]).length;
  spacerCell.style.border = "none"; // Remove border for spacer cell
  spacerCell.style.height = "10px"; // Add height for spacer cell

  // Create header cells
  const headerRow = table.insertRow(3);
  Object.keys(array[0]).forEach((key) => {
    const headerCell = headerRow.insertCell();
    headerCell.innerHTML = key;
    headerCell.style.border = "1px solid #000"; // Add border to header cell
    headerCell.style.padding = "8px"; // Add padding to header cell
    headerCell.style.fontWeight = "bold"; // Make header cell bold
  });

  // Add data rows
  array.forEach((item) => {
    const row = table.insertRow();
    Object.values(item).forEach((value) => {
      const cell = row.insertCell();
      cell.innerHTML = value;
      cell.style.border = "1px solid #000"; // Add border to data cell
      cell.style.padding = "8px"; // Add padding to data cell
    });
  });

  const html = table.outerHTML;

  const blob = new Blob(
    [
      '<html xmlns:x="urn:schemas-microsoft-com:office:excel">',
      "<head>",
      "<!--[if gte mso 9]>",
      "<xml>",
      "<x:ExcelWorkbook>",
      "<x:ExcelWorksheets>",
      "<x:ExcelWorksheet>",
      "<x:Name>Sheet1</x:Name>",
      "<x:WorksheetOptions>",
      "<x:DisplayGridlines/>",
      "</x:WorksheetOptions>",
      "</x:ExcelWorksheet>",
      "</x:ExcelWorksheets>",
      "</x:ExcelWorkbook>",
      "</xml>",
      "<![endif]-->",
      "</head>",
      "<body>",
      html,
      "</body>",
      "</html>",
    ],
    {
      type: "application/vnd.ms-excel;charset=utf-8",
    }
  );

  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);
  link.href = url;
  link.download = `${name}.xls`;
  link.click();
  URL.revokeObjectURL(url);
}

import { jsPDF } from "jspdf";
import "jspdf-autotable";

export function generatePDF(array, name, fromDate, toDate) {
  const doc = new jsPDF("landscape");

  //Global User Data
  const getUserData = JSON.parse(localStorage.getItem("userData"));
  const companyName = getUserData.cName || "";
  const companyAddress = getUserData.Usr_Address || "";
  const companyphone = getUserData.Usr_Phone || "";
  const companyEmail = getUserData.Usr_email || "";
  const companyGst = getUserData.Usr_Gst || "";
  const companyVat = getUserData.Usr_Vat || "";

  function centerText(text, y) {
    const pageWidth = doc.internal.pageSize.getWidth();
    const textWidth = doc.getTextWidth(text);
    const x = (pageWidth - textWidth) / 2;
    doc.text(text, x, y);
  }

  doc.setFont("times", "bold");
  doc.setFontSize(20);
  centerText(companyName, 17);

  doc.setFontSize(12);
  centerText(companyAddress, 25);
  centerText(`VAT TIN: ${companyVat} / GST NO: ${companyGst}`, 32);
  centerText(`EMAIL: ${companyEmail} / MOBILE NO: ${companyphone}`, 38);

  doc.setFont("times", "bold");
  doc.setFontSize(14);
  centerText(`Report Name: ${name}`, 45);
  centerText(`${createDate(fromDate)} - ${createDate(toDate)}`, 55);

  const headers = Object.keys(array[0]);
  const data = array.map((obj) => headers.map((key) => obj[key]));

  doc.autoTable({
    startY: 60,
    head: [headers],
    body: data,
    styles: {
      fontSize: 8,
      lineColor: [0, 0, 0],
      lineWidth: 0.3,
      cellPadding: 1.5,
    },
    headStyles: {
      fillColor: [255, 255, 255],
      textColor: [0, 0, 0],
    },
    bodyStyles: {
      fillColor: [255, 255, 255],
      textColor: [0, 0, 0],
    },
    tableLineColor: [0, 0, 0],
    tableLineWidth: 0.3,
  });

  // Text: Authorized Signature
  doc.setFont("times", "bold");
  doc.setFontSize(10);
  doc.text(`Authorized Signature`, 235, doc.lastAutoTable.finalY + 20);

  // Set autoPrint option to true
  const pdfOutput = doc.output();
  const blob = new Blob([pdfOutput], { type: "application/pdf" });
  const url = URL.createObjectURL(blob);
  const iframe = document.createElement("iframe");
  iframe.onload = function () {
    iframe.contentWindow.print();
  };
  iframe.style.display = "none";
  iframe.src = url;
  document.body.appendChild(iframe);
}
//for one date 
export function generatePDFOneDate(array, name, fromDate, toDate) {
  const doc = new jsPDF("landscape");

  //Global User Data
  const getUserData = JSON.parse(localStorage.getItem("userData"));
  const companyName = getUserData.cName || "";
  const companyAddress = getUserData.Usr_Address || "";
  const companyphone = getUserData.Usr_Phone || "";
  const companyEmail = getUserData.Usr_email || "";
  const companyGst = getUserData.Usr_Gst || "";
  const companyVat = getUserData.Usr_Vat || "";

  function centerText(text, y) {
    const pageWidth = doc.internal.pageSize.getWidth();
    const textWidth = doc.getTextWidth(text);
    const x = (pageWidth - textWidth) / 2;
    doc.text(text, x, y);
  }

  doc.setFont("times", "bold");
  doc.setFontSize(20);
  centerText(companyName, 17);

  doc.setFontSize(12);
  centerText(companyAddress, 25);
  centerText(`VAT TIN: ${companyVat} / GST NO: ${companyGst}`, 32);
  centerText(`EMAIL: ${companyEmail} / MOBILE NO: ${companyphone}`, 38);

  doc.setFont("times", "bold");
  doc.setFontSize(14);
  centerText(`Report Name: ${name}`, 45);
  centerText(`${createDate(fromDate)}`, 55);

  const headers = Object.keys(array[0]);
  const data = array.map((obj) => headers.map((key) => obj[key]));

  doc.autoTable({
    startY: 60,
    head: [headers],
    body: data,
    styles: {
      fontSize: 8,
      lineColor: [0, 0, 0],
      lineWidth: 0.3,
      cellPadding: 1.5,
    },
    headStyles: {
      fillColor: [255, 255, 255],
      textColor: [0, 0, 0],
    },
    bodyStyles: {
      fillColor: [255, 255, 255],
      textColor: [0, 0, 0],
    },
    tableLineColor: [0, 0, 0],
    tableLineWidth: 0.3,
  });

  // Text: Authorized Signature
  doc.setFont("times", "bold");
  doc.setFontSize(10);
  doc.text(`Authorized Signature`, 235, doc.lastAutoTable.finalY + 20);

  // Set autoPrint option to true
  const pdfOutput = doc.output();
  const blob = new Blob([pdfOutput], { type: "application/pdf" });
  const url = URL.createObjectURL(blob);
  const iframe = document.createElement("iframe");
  iframe.onload = function () {
    iframe.contentWindow.print();
  };
  iframe.style.display = "none";
  iframe.src = url;
  document.body.appendChild(iframe);
}

export function generatingPDF(array, name, fromDate, toDate) {
  const doc = new jsPDF("landscape");

  const getUserData = JSON.parse(localStorage.getItem("userData"));
  const companyName = getUserData.cName || "";

  function centerText(text, y) {
    const pageWidth = doc.internal.pageSize.getWidth();
    const textWidth = doc.getTextWidth(text);
    const x = (pageWidth - textWidth) / 2;
    doc.text(text, x, y);
  }

  doc.setFont("times", "bold");
  doc.setFontSize(20);
  centerText(companyName, 10);

  doc.setFont("times", "bold");
  doc.setFontSize(14);
  centerText(`Report Name: ${name}`, 18);
  centerText(`${createDate(fromDate)} - ${createDate(toDate)}`, 26);

  const headers = Object.keys(array[0]);
  const data = array.map((obj) => headers.map((key) => obj[key]));

  doc.autoTable({
    startY: 30,
    head: [headers],
    body: data,
    styles: {
      fontSize: 8,
      lineColor: [0, 0, 0],
      lineWidth: 0.3,
      cellPadding: 1.5,
    },
    headStyles: {
      fillColor: [255, 255, 255],
      textColor: [0, 0, 0],
    },
    bodyStyles: {
      fillColor: [255, 255, 255],
      textColor: [0, 0, 0],
    },
    tableLineColor: [0, 0, 0],
    tableLineWidth: 0.3,
    margin: { top: 38, left: 5, right: 5 },
    columnStyles: {
      0: { columnWidth: "auto" },
    },
  });

  doc.setFont("times", "bold");
  doc.setFontSize(10);
  doc.text(`Authorized Signature`, 235, doc.lastAutoTable.finalY + 20);

  const pdfBlob = doc.output("blob");
  const pdfUrl = URL.createObjectURL(pdfBlob);
  const newTab = window.open(pdfUrl, "_blank");
  const iframe = document.createElement("iframe");
  iframe.style.display = "none";
  iframe.src = pdfUrl;
  iframe.onload = function () {
    newTab.print();
  };
  document.body.appendChild(iframe);

  newTab.onload = function () {
    newTab.document.title = name;
  };
}

export function generateViewPdf(
  array,
  fileName,
  fromDate,
  toDate,
  ledger_name,
  invoice_no,
  totalAmount,
  capitalizedTotalAmountInWords,
  total_entry,
  productdataArray
) {
  const doc = new jsPDF("portrait");
  const getUserData = JSON.parse(localStorage.getItem("userData"));
  const companyName = getUserData.cName || "";
  const companyAddress = getUserData.Usr_Address || "";
  const companyphone = getUserData.Usr_Phone || "";
  const companyEmail = getUserData.Usr_email || "";
  const companyGst = getUserData.Usr_Gst || "";
  const companyVat = getUserData.Usr_Vat || "";
  const companyLogoUrl = getUserData.company_logo_base64 || "";

  function centerText(text, y) {
    const pageWidth = doc.internal.pageSize.getWidth();
    const textWidth = doc.getTextWidth(text);
    const x = (pageWidth - textWidth) / 2;
    doc.text(text, x, y);
  }

  function addSignatureOnEveryPage() {
    const totalPages = doc.internal.getNumberOfPages();
    const pageWidth = doc.internal.pageSize.getWidth();
    const margin = 10;
    const signatureX = pageWidth - margin;

    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      doc.setFont("times", "bold");
      doc.setFontSize(10);
      const textWidth = doc.getTextWidth("Authorized Signature");
      doc.text(
        "Authorized Signature",
        signatureX - textWidth,
        doc.internal.pageSize.height - 10
      );
    }
  }

  doc.addImage(companyLogoUrl, "PNG", 5, 5, 30, 30);
  doc.setFont("times", "bold");
  doc.setFontSize(16);
  centerText(`${companyName} `, 10);
  doc.setFontSize(8);
  centerText(`${companyAddress} `, 15);
  centerText(`VAT TIN: ${companyVat} / GST NO: ${companyGst}`, 20);
  centerText(`EMAIL: ${companyEmail} / MOBILE NO: ${companyphone}`, 25);

  doc.setFont("times", "bold");
  doc.setFontSize(14);
  centerText(`Report Name: ${fileName}`, 35);

  const pageWidth = doc.internal.pageSize.getWidth();
  const underlineY = 40;
  doc.setLineWidth(0.5);
  doc.line(2, underlineY, pageWidth - 10, underlineY);
  doc.setLineWidth(0.5);
  doc.line(2, underlineY + 1, pageWidth - 10, underlineY + 1);

  const leftX = 10;
  const rightX = 105;
  const verticalLineX = rightX - 5;
  doc.text(`Name: ${ledger_name}`, leftX, 50);
  doc.text(`Address: `, leftX, 58);
  doc.text(`Invoice No: ${invoice_no}`, rightX, 50);
  doc.text(
    `Invoice Period: ${createDate(fromDate)} - ${createDate(toDate)}`,
    rightX,
    58
  );

  doc.setLineWidth(0.5);
  doc.line(verticalLineX, 45, verticalLineX, 60);

  const headers = Object.keys(array[0]);
  const data = array.map((obj) => headers.map((key) => obj[key]));

  let startY = 65;
  let remainingData = data;

  while (remainingData.length > 0) {
    const chunk = remainingData.splice(0, 25);
    doc.autoTable({
      startY,
      head: [headers],
      body: chunk,
      styles: {
        fontSize: 8,
        lineColor: [0, 0, 0],
        lineWidth: 0.3,
        cellPadding: 1.5,
      },
      headStyles: {
        lineWidth: 0.5,
        lineColor: [0, 0, 0],
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0],
        fontStyle: "bold",
      },
      bodyStyles: {
        lineWidth: 0,
        textColor: [0, 0, 0],
        fillColor: [255, 255, 255],
        fillOpacity: 1,
      },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      margin: { top: 38, left: 5, right: 5 },
      columnStyles: {
        0: { columnWidth: "auto" },
      },
    });

    const underliney = 252;
    doc.setLineWidth(0.5);
    doc.line(10, underliney, pageWidth - 10, underliney);

    doc.setFont("times", "bold");
    doc.setFontSize(10);
    const footerY = doc.internal.pageSize.getHeight() - 40;
    const leftXFooter = 10;
    const rightXFooter = pageWidth - 40;

    doc.setFontSize(8);
    let currentY = doc.internal.pageSize.getHeight() - 50;
    productdataArray.forEach((product) => {
      doc.text(`${product.Date}`, 10, currentY);
      const slipNo = parseFloat(product["Slip No"]).toFixed(2);
      doc.text(`${slipNo}`, 70, currentY);
      const billNo = parseFloat(product["Bill No"]).toFixed(2);
      doc.text(`${billNo}`, 90, currentY);
      currentY -= 5;
    });

    doc.text(
      `Rupees ${capitalizedTotalAmountInWords} Only`,
      leftXFooter,
      footerY
    );
    doc.text(`Total: ${totalAmount.toFixed(2)}`, rightXFooter, footerY);

    const underlineY = 260;
    doc.setLineWidth(1);
    doc.line(10, underlineY, pageWidth - 10, underlineY);

    doc.setFont("times", "bold");
    doc.setFontSize(10);
    const footerText = "E & O.E ";
    const pagewidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const footerTextWidth = doc.getTextWidth(footerText);
    const companyNameWidth = doc.getTextWidth(companyName);
    const xFooter = pagewidth - footerTextWidth - 20;
    const xCompanyName = pagewidth - companyNameWidth - 10;
    const yFooter = pageHeight - 30;
    const yCompanyName = pageHeight - 25;
    doc.text(footerText, xFooter, yFooter);
    doc.text(companyName, xCompanyName, yCompanyName);

    addSignatureOnEveryPage();
    if (remainingData.length > 0) {
      doc.addPage();
    }
    startY = 20;
  }

  doc.setFont("times", "bold");
  doc.setFontSize(8);
  const footerYForEntries = doc.internal.pageSize.getHeight() - 30;
  doc.text(
    `TOTAL NO. OF MEMOS ATTACHED: ${total_entry}`,
    10,
    footerYForEntries
  );

  const pdfBlob = doc.output("blob");
  const pdfUrl = URL.createObjectURL(pdfBlob);
  const newTab = window.open(pdfUrl, "_blank");
  const iframe = document.createElement("iframe");
  iframe.style.display = "none";
  iframe.src = pdfUrl;
  iframe.onload = function () {
    newTab.print();
  };
  document.body.appendChild(iframe);

  newTab.onload = function () {
    newTab.document.title = fileName;
  };
}

export function generateviewPdf(
  dataArray,
  productdataArray,
  fileName,
  fromDate,
  toDate,
  clientName,
  capitalizedTotalAmountInWords,
  totalAmount,
  invoiceNo,
  invoicePeriod,
  totalRows
) {
const doc = new jsPDF("portrait");
const getUserData = JSON.parse(localStorage.getItem("userData"));
const companyName = getUserData.cName || "";
const companyAddress = getUserData.Usr_Address || "";
const companyphone = getUserData.Usr_Phone || "";
const companyEmail = getUserData.Usr_email || "";
const companyGst = getUserData.Usr_Gst || "";
const companyVat = getUserData.Usr_Vat || "";
const companyLogoUrl = getUserData.company_logo_base64 || "";

function centerText(text, y) {
  const pageWidth = doc.internal.pageSize.getWidth();
  const textWidth = doc.getTextWidth(text);
  const x = (pageWidth - textWidth) / 2;
  doc.text(text, x, y);
}

function addSignatureOnEveryPage() {
  const totalPages = doc.internal.getNumberOfPages();
  const pageWidth = doc.internal.pageSize.getWidth();
  const margin = 10;
  const signatureX = pageWidth - margin;

  for (let i = 1; i <= totalPages; i++) {
    doc.setPage(i);
    doc.setFont("times", "bold");
    doc.setFontSize(10);
    const textWidth = doc.getTextWidth("Authorized Signature");
    doc.text(
      "Authorized Signature",
      signatureX - textWidth,
      doc.internal.pageSize.height - 10
    );
  }
}

doc.addImage(companyLogoUrl, "PNG", 5, 5, 30, 30);
doc.setFont("times", "bold");
doc.setFontSize(16);
centerText(`${companyName} `, 10);
doc.setFontSize(8);
centerText(`${companyAddress} `, 15);
centerText(`VAT TIN: ${companyVat} / GST NO: ${companyGst}`, 20);
centerText(`EMAIL: ${companyEmail} / MOBILE NO: ${companyphone}`, 25);

doc.setFont("times", "bold");
doc.setFontSize(14);
centerText(`Report Name: ${fileName}`, 35);

const pageWidth = doc.internal.pageSize.getWidth();
const underlineY = 40;
doc.setLineWidth(0.5);
doc.line(2, underlineY, pageWidth - 10, underlineY);
doc.setLineWidth(0.5);
doc.line(2, underlineY + 1, pageWidth - 10, underlineY + 1);

const leftX = 10;
const rightX = 105;
const verticalLineX = rightX - 5;
doc.text(`Name: ${clientName}`, leftX, 50);
doc.text(`Address: `, leftX, 58);
doc.text(`Invoice No: ${invoiceNo}`, rightX, 50);
doc.text(
  `Invoice Period: ${invoicePeriod}`,
  rightX,
  58
);

doc.setLineWidth(0.5);
doc.line(verticalLineX, 45, verticalLineX, 60);

// Fixed section here
const headers = Object.keys(dataArray[0]);
const data = dataArray.map((obj) => headers.map((key) => obj[key]));

let startY = 65;
let remainingData = data;

while (remainingData.length > 0) {
  const chunk = remainingData.splice(0, 25);
  doc.autoTable({
    startY,
    head: [headers],
    body: chunk,
    styles: {
      fontSize: 8,
      lineColor: [0, 0, 0],
      lineWidth: 0.3,
      cellPadding: 1.5,
    },
    headStyles: {
      lineWidth: 0.5,
      lineColor: [0, 0, 0],
      fillColor: [255, 255, 255],
      textColor: [0, 0, 0],
      fontStyle: "bold",
    },
    bodyStyles: {
      lineWidth: 0,
      textColor: [0, 0, 0],
      fillColor: [255, 255, 255],
      fillOpacity: 1,
    },
    alternateRowStyles: {
      fillColor: [255, 255, 255],
    },
    margin: { top: 38, left: 5, right: 5 },
    columnStyles: {
      0: { columnWidth: "auto" },
    },
  });

  const underliney = 252;
  doc.setLineWidth(0.5);
  doc.line(10, underliney, pageWidth - 10, underliney);

  doc.setFont("times", "bold");
  doc.setFontSize(10);
  const footerY = doc.internal.pageSize.getHeight() - 40;
  const leftXFooter = 10;
  const rightXFooter = pageWidth - 40;

  doc.setFontSize(8);
  let currentY = doc.internal.pageSize.getHeight() - 50;
  productdataArray.forEach((product) => {
    doc.text(`${product.Date}`, 10, currentY);
    currentY -= 5;
  });

  doc.text(
    `Rupees ${capitalizedTotalAmountInWords} Only`,
    leftXFooter,
    footerY
  );
  doc.text(`Total: ${totalAmount.toFixed(2)}`, rightXFooter, footerY);

  const underlineY = 260;
  doc.setLineWidth(1);
  doc.line(10, underlineY, pageWidth - 10, underlineY);

  doc.setFont("times", "bold");
  doc.setFontSize(10);
  const footerText = "E & O.E ";
  const pagewidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const footerTextWidth = doc.getTextWidth(footerText);
  const companyNameWidth = doc.getTextWidth(companyName);
  const xFooter = pagewidth - footerTextWidth - 20;
  const xCompanyName = pagewidth - companyNameWidth - 10;
  const yFooter = pageHeight - 30;
  const yCompanyName = pageHeight - 25;
  doc.text(footerText, xFooter, yFooter);
  doc.text(companyName, xCompanyName, yCompanyName);

  addSignatureOnEveryPage();
  if (remainingData.length > 0) {
    doc.addPage();
  }
  startY = 20;
}

doc.setFont("times", "bold");
doc.setFontSize(8);
const footerYForEntries = doc.internal.pageSize.getHeight() - 30;
doc.text(
  `TOTAL NO. OF MEMOS ATTACHED: ${totalRows}`,
  10,
  footerYForEntries
);

const pdfBlob = doc.output("blob");
const pdfUrl = URL.createObjectURL(pdfBlob);
const newTab = window.open(pdfUrl, "_blank");
const iframe = document.createElement("iframe");
iframe.style.display = "none";
iframe.src = pdfUrl;
iframe.onload = function () {
  newTab.print();
};
document.body.appendChild(iframe);

newTab.onload = function () {
  newTab.document.title = fileName;
};
}

export function downloadExcel(array, name, fromDate, toDate) {
  const table = document.createElement("table");
  table.style.borderCollapse = "collapse";

  //Global User Data
  const getUserData = JSON.parse(localStorage.getItem("userData"));
  const companyName = getUserData.cName || "";
  const companyAddress = getUserData.Usr_Address || "";
  const companyphone = getUserData.Usr_Phone || "";
  const companyEmail = getUserData.Usr_email || "";
  const companyGst = getUserData.Usr_Gst || "";
  const companyVat = getUserData.Usr_Vat || "";

  // Format the toDate to yy/mm/dd
  const toDateObj = new Date(toDate);
  const yy = toDateObj.getFullYear().toString(); // Get the last two digits of the year
  const mm = String(toDateObj.getMonth() + 1).padStart(2, "0"); // Month is 0-based, so add 1
  const dd = String(toDateObj.getDate()).padStart(2, "0");

  // Format the toDate to yy/mm/dd
  const toDateObj1 = new Date(fromDate);
  const y = toDateObj1.getFullYear().toString(); // Get the last two digits of the year
  const m = String(toDateObj1.getMonth() + 1).padStart(2, "0"); // Month is 0-based, so add 1
  const d = String(toDateObj1.getDate()).padStart(2, "0");

  // Add a row for company name
  const infoRow = table.insertRow(0);
  const infoCell = infoRow.insertCell();
  infoCell.colSpan = Object.keys(array[0]).length;
  infoCell.innerHTML = ` <strong>${companyName}</strong>`;
  infoCell.style.border = "1px solid #000"; // Add border to info cell
  infoCell.style.padding = "8px"; // Add padding to info cell
  infoCell.style.textAlign = "center"; // Add taxt align to info cell
  infoCell.style.backgroundColor = "#DEF7DF"; // Add background color to info cell
  infoCell.style.fontSize = "30px"; // Add background color to info cell

  // Add a row for company address
  const infoRow1 = table.insertRow(1);
  const infoCell1 = infoRow1.insertCell();
  infoCell1.colSpan = Object.keys(array[0]).length;
  infoCell1.innerHTML = ` ${companyAddress} `;
  infoCell1.style.border = "1px solid #000"; // Add border to info cell
  infoCell1.style.padding = "8px"; // Add padding to info cell
  infoCell1.style.textAlign = "center"; // Add taxt align to info cell
  infoCell1.style.backgroundColor = "#DEF7DF"; // Add background color to info cell

  // Add a row for company vat no. and company gst no
  const infoRow2 = table.insertRow(2);
  const infoCell2 = infoRow2.insertCell();
  infoCell2.colSpan = Object.keys(array[0]).length;
  infoCell2.innerHTML = ` <strong>VAT TIN : </strong> ${companyVat}, /<strong>GST NO:</strong> ${companyGst}`;
  infoCell2.style.border = "1px solid #000"; // Add border to info cell
  infoCell2.style.padding = "8px"; // Add padding to info cell
  infoCell2.style.textAlign = "center"; // Add taxt align to info cell
  infoCell2.style.backgroundColor = "#DEF7DF"; // Add background color to info cell

  // Add a row for company phone no. and company email
  const infoRow3 = table.insertRow(3);
  const infoCell3 = infoRow3.insertCell();
  infoCell3.colSpan = Object.keys(array[0]).length;
  infoCell3.innerHTML = ` <strong>PHONE NO :</strong> ${companyphone}, <strong>EMAIL:</strong> ${companyEmail}`;
  infoCell3.style.border = "1px solid #000"; // Add border to info cell
  infoCell3.style.padding = "8px"; // Add padding to info cell
  infoCell3.style.textAlign = "center"; // Add taxt align to info cell
  infoCell3.style.backgroundColor = "#DEF7DF"; // Add background color to info cell

  // Add a row for company phone no. and company email
  const infoRow4 = table.insertRow(4);
  const infoCell4 = infoRow4.insertCell();
  infoCell4.colSpan = Object.keys(array[0]).length;
  infoCell4.innerHTML = `<strong>Report Name :</strong> <strong>${name}</strong> `;
  infoCell4.style.border = "1px solid #000"; // Add border to info cell
  infoCell4.style.padding = "8px"; // Add padding to info cell
  infoCell4.style.textAlign = "center"; // Add taxt align to info cell
  infoCell4.style.backgroundColor = "#DEF7DF"; // Add background color to info cell

  // Add a row for file name
  const infoRow5 = table.insertRow(5);
  const infoCell5 = infoRow5.insertCell();
  infoCell5.colSpan = Object.keys(array[0]).length;
  infoCell5.innerHTML = `<strong>From Date :</strong> ${y}-${m}-${d}, <strong>To Date:</strong> ${yy}-${mm}-${dd}`;
  infoCell5.style.border = "1px solid #000"; // Add border to info cell
  infoCell5.style.padding = "8px"; // Add padding to info cell
  infoCell5.style.textAlign = "center"; // Add taxt align to info cell
  infoCell5.style.backgroundColor = "#DEF7DF"; // Add background color to info cell

  // Create a spacer row
  const spacerRow = table.insertRow(6);
  const spacerCell = spacerRow.insertCell();
  spacerCell.colSpan = Object.keys(array[0]).length;
  spacerCell.style.border = "none"; // Remove border for spacer cell
  spacerCell.style.height = "10px"; // Add height for spacer cell

  // Create header cells
  const headerRow = table.insertRow(6);
  Object.keys(array[0]).forEach((key) => {
    const headerCell = headerRow.insertCell();
    headerCell.innerHTML = key;
    headerCell.style.border = "1px solid #000"; // Add border to header cell
    headerCell.style.padding = "8px"; // Add padding to header cell
    headerCell.style.fontWeight = "bold"; // Make header cell bold
  });

  // Add data rows
  array.forEach((item) => {
    const row = table.insertRow();
    Object.values(item).forEach((value) => {
      const cell = row.insertCell();
      cell.innerHTML = value;
      cell.style.border = "1px solid #000"; // Add border to data cell
      cell.style.padding = "8px"; // Add padding to data cell
    });
  });

  const html = table.outerHTML;

  const blob = new Blob(
    [
      '<html xmlns:x="urn:schemas-microsoft-com:office:excel">',
      "<head>",
      "<!--[if gte mso 9]>",
      "<xml>",
      "<x:ExcelWorkbook>",
      "<x:ExcelWorksheets>",
      "<x:ExcelWorksheet>",
      "<x:Name>Sheet1</x:Name>",
      "<x:WorksheetOptions>",
      "<x:DisplayGridlines/>",
      "</x:WorksheetOptions>",
      "</x:ExcelWorksheet>",
      "</x:ExcelWorksheets>",
      "</x:ExcelWorkbook>",
      "</xml>",
      "<![endif]-->",
      "</head>",
      "<body>",
      html,
      "</body>",
      "</html>",
    ],
    {
      type: "application/vnd.ms-excel;charset=utf-8",
    }
  );

  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);
  link.href = url;
  link.download = `${name}.xls`;
  link.click();
  URL.revokeObjectURL(url);
}

//for one date 
export function downloadExcelOneDate(array, name, fromDate, toDate) {
  const table = document.createElement("table");
  table.style.borderCollapse = "collapse";

  //Global User Data
  const getUserData = JSON.parse(localStorage.getItem("userData"));
  const companyName = getUserData.cName || "";
  const companyAddress = getUserData.Usr_Address || "";
  const companyphone = getUserData.Usr_Phone || "";
  const companyEmail = getUserData.Usr_email || "";
  const companyGst = getUserData.Usr_Gst || "";
  const companyVat = getUserData.Usr_Vat || "";

  // Format the toDate to yy/mm/dd
  const toDateObj = new Date(toDate);
  const yy = toDateObj.getFullYear().toString(); // Get the last two digits of the year
  const mm = String(toDateObj.getMonth() + 1).padStart(2, "0"); // Month is 0-based, so add 1
  const dd = String(toDateObj.getDate()).padStart(2, "0");

  // Format the toDate to yy/mm/dd
  const toDateObj1 = new Date(fromDate);
  const y = toDateObj1.getFullYear().toString(); // Get the last two digits of the year
  const m = String(toDateObj1.getMonth() + 1).padStart(2, "0"); // Month is 0-based, so add 1
  const d = String(toDateObj1.getDate()).padStart(2, "0");

  // Add a row for company name
  const infoRow = table.insertRow(0);
  const infoCell = infoRow.insertCell();
  infoCell.colSpan = Object.keys(array[0]).length;
  infoCell.innerHTML = ` <strong>${companyName}</strong>`;
  infoCell.style.border = "1px solid #000"; // Add border to info cell
  infoCell.style.padding = "8px"; // Add padding to info cell
  infoCell.style.textAlign = "center"; // Add taxt align to info cell
  infoCell.style.backgroundColor = "#DEF7DF"; // Add background color to info cell
  infoCell.style.fontSize = "30px"; // Add background color to info cell

  // Add a row for company address
  const infoRow1 = table.insertRow(1);
  const infoCell1 = infoRow1.insertCell();
  infoCell1.colSpan = Object.keys(array[0]).length;
  infoCell1.innerHTML = ` ${companyAddress} `;
  infoCell1.style.border = "1px solid #000"; // Add border to info cell
  infoCell1.style.padding = "8px"; // Add padding to info cell
  infoCell1.style.textAlign = "center"; // Add taxt align to info cell
  infoCell1.style.backgroundColor = "#DEF7DF"; // Add background color to info cell

  // Add a row for company vat no. and company gst no
  const infoRow2 = table.insertRow(2);
  const infoCell2 = infoRow2.insertCell();
  infoCell2.colSpan = Object.keys(array[0]).length;
  infoCell2.innerHTML = ` <strong>VAT TIN : </strong> ${companyVat}, /<strong>GST NO:</strong> ${companyGst}`;
  infoCell2.style.border = "1px solid #000"; // Add border to info cell
  infoCell2.style.padding = "8px"; // Add padding to info cell
  infoCell2.style.textAlign = "center"; // Add taxt align to info cell
  infoCell2.style.backgroundColor = "#DEF7DF"; // Add background color to info cell

  // Add a row for company phone no. and company email
  const infoRow3 = table.insertRow(3);
  const infoCell3 = infoRow3.insertCell();
  infoCell3.colSpan = Object.keys(array[0]).length;
  infoCell3.innerHTML = ` <strong>PHONE NO :</strong> ${companyphone}, <strong>EMAIL:</strong> ${companyEmail}`;
  infoCell3.style.border = "1px solid #000"; // Add border to info cell
  infoCell3.style.padding = "8px"; // Add padding to info cell
  infoCell3.style.textAlign = "center"; // Add taxt align to info cell
  infoCell3.style.backgroundColor = "#DEF7DF"; // Add background color to info cell

  // Add a row for company phone no. and company email
  const infoRow4 = table.insertRow(4);
  const infoCell4 = infoRow4.insertCell();
  infoCell4.colSpan = Object.keys(array[0]).length;
  infoCell4.innerHTML = `<strong>Report Name :</strong> <strong>${name}</strong> `;
  infoCell4.style.border = "1px solid #000"; // Add border to info cell
  infoCell4.style.padding = "8px"; // Add padding to info cell
  infoCell4.style.textAlign = "center"; // Add taxt align to info cell
  infoCell4.style.backgroundColor = "#DEF7DF"; // Add background color to info cell

  // Add a row for file name
  const infoRow5 = table.insertRow(5);
  const infoCell5 = infoRow5.insertCell();
  infoCell5.colSpan = Object.keys(array[0]).length;
  infoCell5.innerHTML = `<strong> Date :</strong> ${y}-${m}-${d}`;
  infoCell5.style.border = "1px solid #000"; // Add border to info cell
  infoCell5.style.padding = "8px"; // Add padding to info cell
  infoCell5.style.textAlign = "center"; // Add taxt align to info cell
  infoCell5.style.backgroundColor = "#DEF7DF"; // Add background color to info cell

  // Create a spacer row
  const spacerRow = table.insertRow(6);
  const spacerCell = spacerRow.insertCell();
  spacerCell.colSpan = Object.keys(array[0]).length;
  spacerCell.style.border = "none"; // Remove border for spacer cell
  spacerCell.style.height = "10px"; // Add height for spacer cell

  // Create header cells
  const headerRow = table.insertRow(6);
  Object.keys(array[0]).forEach((key) => {
    const headerCell = headerRow.insertCell();
    headerCell.innerHTML = key;
    headerCell.style.border = "1px solid #000"; // Add border to header cell
    headerCell.style.padding = "8px"; // Add padding to header cell
    headerCell.style.fontWeight = "bold"; // Make header cell bold
  });

  // Add data rows
  array.forEach((item) => {
    const row = table.insertRow();
    Object.values(item).forEach((value) => {
      const cell = row.insertCell();
      cell.innerHTML = value;
      cell.style.border = "1px solid #000"; // Add border to data cell
      cell.style.padding = "8px"; // Add padding to data cell
    });
  });

  const html = table.outerHTML;

  const blob = new Blob(
    [
      '<html xmlns:x="urn:schemas-microsoft-com:office:excel">',
      "<head>",
      "<!--[if gte mso 9]>",
      "<xml>",
      "<x:ExcelWorkbook>",
      "<x:ExcelWorksheets>",
      "<x:ExcelWorksheet>",
      "<x:Name>Sheet1</x:Name>",
      "<x:WorksheetOptions>",
      "<x:DisplayGridlines/>",
      "</x:WorksheetOptions>",
      "</x:ExcelWorksheet>",
      "</x:ExcelWorksheets>",
      "</x:ExcelWorkbook>",
      "</xml>",
      "<![endif]-->",
      "</head>",
      "<body>",
      html,
      "</body>",
      "</html>",
    ],
    {
      type: "application/vnd.ms-excel;charset=utf-8",
    }
  );

  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);
  link.href = url;
  link.download = `${name}.xls`;
  link.click();
  URL.revokeObjectURL(url);
}